import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import styles from './styles';
import { ActivationMap } from './ActivationMap';
import { AppState } from '../../redux/store';
import { selectPropertiesActiveLocks } from '../../redux/selectors/properties';
import { propertiesActiveLocksRequest } from '../../redux/actions/properties';

const mapStateToProps = (state: AppState) => ({
  activePropertiesLocks: selectPropertiesActiveLocks(state),
});

const mapDispatchToProps = {
  loadActivePropertiesLocks: propertiesActiveLocksRequest,
};

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(ActivationMap));
